import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { green, yellow } from "@material-ui/core/colors";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Snackbar,
  Typography,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import Swal from "sweetalert2";
import Paper from "@material-ui/core/Paper";
import "./MakeEntry.css";
import moment from "moment";
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import EventBusyIcon from '@material-ui/icons/EventBusy';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import withReactContent from "sweetalert2-react-content";
import EntryForm from './EntryForm';

const SwalJsx = withReactContent(Swal);

//The purpose of this page is to capture the student's activity for the past pay period
class MakeEntry extends Component {

  
  constructor(props) {
    super(props);
    this.backFromForm = this.backFromForm.bind(this);
    this.state = {
      selected_pay_day_ymd: null,
      status_rows: [],
      initialEntriesLoadNumber: this.props.entriesLoadNumber,
      savingEntriesLoadNumber: null,
      entries: [props.entries],
  
      //state info for what was the entry form
      lcf_id: this.props.user.lcf_id,

      //error values used to conditionally render error toasts, default is false
      error: false,
      pay_day_error: false,
      dupeEntry: false,
      toggle: false,
    };

  }

  componentDidMount() {
    this.props.dispatch({ type: "GET_STUDENTS" });
    this.props.dispatch({ type: "FETCH_STUDENT_HISTORY", payload: this.props.user.lcf_id});
    this.props.dispatch({ type: "FETCH_ENTRIES_FOR_ADMIN" });

    const payDayInfo = this.findCurrentPayDay();
    const statusRows = [
      this.buildStatusRow(payDayInfo.pay_day_moment),
      this.buildStatusRow(moment(payDayInfo.pay_day_moment).add(-2, "week")),
      this.buildStatusRow(moment(payDayInfo.pay_day_moment).add(-4, "week"))
    ];

    this.setState({
      total_days: 10,
      status_rows: statusRows
    });
  }

  /** @param payDay {moment.Moment} */
  buildStatusRow(payDay) {
    const cutOff = moment(payDay).add(-3, 'day').add(-1, 'minute');
    const row = {
      period_start: moment(payDay).add(-2, "week"),
      period_end: moment(payDay).add(-1, "day"),
      pay_day: payDay,
      pay_day_ymd: payDay.format('YYYY-MM-DD'),
      editable_cut_off: cutOff.format('MMM D [by] hh:mm a'),
      editable: moment().add(-20, 'minute').isBefore(cutOff)
    };
    row.title = `${row.period_start.format("MMM D")} - ${row.period_end.format("MMM D, YYYY")}`;
    row.long_title = `${row.period_start.format("MMMM D")} - ${row.period_end.format("MMMM D, YYYY")}`;
    return row;
  }

  getEntryToMatchPayDay(studentLcfId, payDayYmd) {
    const allEntries = (this.props.entries || []).concat(this.props.studentHistory || []);
    return allEntries.find(e => {
      if (e.lcf_id !== studentLcfId) {
        return false;
      }
      if (typeof e.pay_day === 'string') {
        return e.pay_day.substr(0, 10) === payDayYmd;
      } else {
        return payDayYmd === moment(e.pay_day).format('YYYY-MM-DD');
      }
    });
  }

  /** @returns {{ pay_day_moment: moment.Moment, pay_day: string, previous_pay_day: string, counter: number }} */
  findCurrentPayDay() {
    let today = moment();
    let previous_pay_day = moment("2020-09-21T00:00:00.000-05"); //midnight central time
    let pay_day = moment(previous_pay_day);
    let counter = 0;
    while (today >= pay_day) {
      counter++;
      previous_pay_day = pay_day;
      pay_day = moment(previous_pay_day).add(2, "week");
    }
    previous_pay_day = previous_pay_day.format("MMMM Do YYYY");
    return {
      pay_day_moment: pay_day,
      pay_day: pay_day.format("MMMM Do YYYY"),
      previous_pay_day,
      counter
    };
  }

  setSelectedRow(row) {

    if(!row) {
      this.setState({ selected_pay_day_ymd: null });
      return;
    }
    const entry = this.getEntryToMatchPayDay(this.state.lcf_id, row.pay_day_ymd);
    if (!entry && !row.editable) {
      SwalJsx.fire({
        title: `${row.pay_day.format('MMMM D')} Pay Day Information`,
        html: (<div className="payday-swal-content">
          No information has been submitted for this pay day,
          and the due date for entry was {row.editable_cut_off}.
        </div>),
        showCancelButton: false,
        confirmButtonColor: "#5cb85c",
        confirmButtonText: "Dismiss"
      });
      return;
    }
    this.setState({ selected_pay_day_ymd: row.pay_day_ymd });
    if (!entry) {
      return;
    }
    SwalJsx.fire({
      title: `${row.pay_day.format('MMMM D')} Pay Day Information`,
      html: this.buildEntryPreview(entry),
      showCancelButton: false,
      confirmButtonColor: "#5cb85c",
      confirmButtonText: "Dismiss",
    });
  }

  buildEntryPreview(entry) {
    const hasFullAttendanceInfo = typeof (entry.days_absent) !== 'undefined'
      || typeof (entry.days_tardy) !== 'undefined'
      || typeof (entry.days_late) !== 'undefined'
      || typeof (entry.days_truant) !== 'undefined';
    let attendHtml;
    if (hasFullAttendanceInfo) {
      attendHtml = (<div>
        <div>3a. Days absent: {entry.days_absent}</div>
        <div>3b. Days tardy: {entry.days_tardy}</div>
        <div>3c. Days late: {entry.days_late}</div>
        <div>3d. Days truant: {entry.days_truant}</div>
      </div>);
    }
    return (<div className="payday-swal-content">
      <div>1. Passing classes: {entry.pass_class ? "Yes" : "No"}</div>
      <div>2. GPA: {entry.gpa}</div>
      {attendHtml}
      <div>4. Had detention hours: {entry.had_detention ? "Yes" : "No"}</div>
      <div>5. Job or after school activities: {entry.act_or_job ? "Yes" : "No"}</div>
      <div>6. substance_abuse free: {entry.substance_abuse_free ? "Yes" : "No"}</div>
      <div>7. 40 or more service hours: {entry.service_hrs_met ? "Yes" : "No"}</div>
      <div>8. Homeroom attendence: {entry.hw_rm_attended ? "Yes" : "No"}</div>
      <div>9. Comments: {entry.comments}</div>
    </div>);
  }

  renderSummaryRowListItem(lcfId, row) {
    const entry = this.getEntryToMatchPayDay(lcfId, row.pay_day_ymd);
    let icon;
    let status;
    if (!entry && row.editable) {
      icon = <CalendarTodayIcon />;
      status = "Entry due " + row.editable_cut_off;
    } else if (!entry) {
      icon = <EventBusyIcon style={{ color: yellow[700] }} />;
      status = "No entry";
    } else if (entry.did_we_pay === "Yes" || entry.did_we_pay === "yes") {
      // History entry that's been paid
      const money = Number(entry.total).toFixed(2);
      icon = <AttachMoneyIcon style={{ color: green[700] }} />;
      status = `Submitted ${moment(entry.date_submitted).format('MMM D')}; $${money} paid`;
    } else if (typeof entry.did_we_pay !== "undefined") {
      // History entry, but did_we_pay seems to be falsy.
      icon = <EventAvailableIcon style={{ color: yellow[700] }} />;
      status = `Submitted ${moment(entry.date_submitted).format('MMM D')}`;
    } else {
      icon = <EventAvailableIcon style={{ color: green[700] }} />;
      status = `Submitted ${moment(entry.date_submitted).format('MMM D')}`;
    }
    return {
      entry,
      html:
        <ListItem button key={row.pay_day_ymd}
            selected={this.state.selected_pay_day_ymd === row.pay_day_ymd}
            onClick={() => this.setSelectedRow(row)}>
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText primary={row.title} secondary={status} />
        </ListItem>
    };
  }

  render() {
    const student = this.props.students.find(s => s.lcf_id === this.props.user.lcf_id);
    if (!student || this.state.initialEntriesLoadNumber === this.props.entriesLoadNumber) {
      return (<div className="make-entry-loading">Loading...</div>);
    }

    const isSaving = this.state.savingEntriesLoadNumber
      && this.state.savingEntriesLoadNumber === this.props.entriesLoadNumber;

    const savingSnackbar = <Snackbar open={isSaving} message="Saving..." />;

    const marks = [
      {
        value: 0,
        label: "0"
      },
      {
        value: this.state.total_days,
        label: this.state.total_days,
      }
    ];

    if (student.inactive === "yes") {
      return (
        <div>
          <Paper elevation={5} style={{ margin: "5%", padding: "5%" }}>
            <center>
              <h2>
                Sorry, you cannot make an entry at this moment. Your account
                is currently inactive, please contact the admin for further
                details.
              </h2>
            </center>
            <center>
              <h2>Thank you!</h2>
            </center>
          </Paper>
        </div>
      );
    }

    const summaryRows = this.state.status_rows.map(row => this.renderSummaryRowListItem(student.lcf_id, row));
    const statusTable = (
      <div className="payday-summary">
        <Paper elevation={5}>
          <Typography variant="h6">Recent Pay Periods</Typography>
          <List dense>
            {summaryRows.map(r => r.html)}
          </List>
        </Paper>
        { summaryRows.some(r => !r.entry) || (
          <Alert severity="info" elevation={5}>
            Nice -- all pay periods listed here have entries.
            Check back next pay period!
          </Alert>
        )}
        { savingSnackbar }
      </div>
    );

    if (!this.state.selected_pay_day_ymd) {
      return statusTable;
    }

    const row = this.state.status_rows.find(r => r.pay_day_ymd === this.state.selected_pay_day_ymd);
    const entry = this.getEntryToMatchPayDay(student.lcf_id, this.state.selected_pay_day_ymd);
    if (entry) {
      return statusTable;
    }

    return (<EntryForm
      entriesLoadNumber={this.props.entriesLoadNumber}
      parent_lcf_id={this.state.lcf_id}
      stu_entry={null}  // parent pass in student info if has
      backButtonFunc={this.backFromForm}
    />);
  }

  componentDidUpdate(prevProps) {
    // Detect when a "save entry" completes and show success to the user.
    if (this.props.entriesLoadNumber === prevProps.entriesLoadNumber) {
      return;
    }
    const wasSaving = this.state.savingEntriesLoadNumber
      && this.state.savingEntriesLoadNumber < this.props.entriesLoadNumber;
    if (wasSaving) {
      Swal.fire("Success!", "Your entry has been saved.", "success");
      this.setState({
        selected_pay_day_ymd: null,
        savingEntriesLoadNumber: null
      });
    }
  }
  
  backFromForm(goHome) {
    if (goHome) {
      this.props.history.push("/home");
      return;
    }
    this.setSelectedRow();
  }

}

const mapStateToProps = (state) => ({
  user: state.user,
  entries: state.students.studententriesadmin,
  entriesLoadNumber: state.students.entriesLoadNumber,
  students: state.students.studentlist,
  studentHistory: state.studentHistory.studentHistoryReducer
});

export default withRouter(connect(mapStateToProps)(MakeEntry));
